import React, { useState, useEffect } from "react";
import "./BlogIntro.css";
import TextField from "@material-ui/core/TextField";
import { Button, CircularProgress } from "@material-ui/core";
import LinkedInDescriptionInput from "../DescriptionInput/LinkedInDescription";
import { useDispatch, useSelector } from 'react-redux';
import { generateBlogIntro } from '../../../../../actions/generateActions';
import { useLocation } from 'react-router-dom';

const BlogIntro = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [errorMessage, setErrorMessage] = useState("");
    const [blogTitle, setBlogTitle] = useState("");
    const [blogDesc, setBlogDesc] = useState("");

    const blogIntroGenerate = useSelector(state => state.blogIntroGenerate);
    

    // React.useEffect(() => {
        
    // },[]);

    const { loading, error } = blogIntroGenerate;

    const handleBlogIntro = e => {
        e.preventDefault();
        if (blogTitle, blogDesc) {
            setErrorMessage("");
            dispatch(generateBlogIntro(blogTitle, blogDesc));
        } else {
            setErrorMessage("Fill out both the details first")
        }
    }

    useEffect(() => {
        if (location.state) {
            setBlogTitle(location.state.blogTitle);
            setBlogDesc(location.state.description);
        }
    }, [location.state])

    return (
        <div className="blogIntro">
            {(error || errorMessage) && <h3> {error || errorMessage}</h3>}
            {" "}
            <TextField
                required
                value={blogTitle}
                onChange={e => setBlogTitle(e.target.value)}
                id="outlined-required"
                label="Blog Title"
                variant="outlined"
                margin="dense"
            />
            <LinkedInDescriptionInput label="Blog Description" descValue={blogDesc} changeDesc={setBlogDesc} />
            <div className="mainsoftwaresidebar__content__submitbutton">
                {" "}
                {loading ? <CircularProgress /> : (
                    <Button
                        disableRipple={true}
                        disableFocusRipple={true}
                        onClick={handleBlogIntro}
                        variant="outlined"
                        size="small"
                        className="hover__backgroundchange__buttons"
                    >
                        Generate
                    </Button>
                )}
                {/* <p style={{ marginTop: "0.5rem" }}>
                    <span className="dollar__sign">
                        <i className="fas fa-dollar-sign"></i>
                    </span>
                    <span className="generate__coins__display">15 coins</span>
                </p> */}
            </div>
        </div >
    );
}

export default BlogIntro;
